module.exports = __webpack_public_path__ + "img/wz-8-6-5.fad0a403.jpg";